/**
 * Purpose:
 *   Renders button content (icon + label) with proper positioning.
 */

import React from 'react';
import { cx } from '@/util/functions/cx';
import { ButtonIcon } from './ButtonIcon';
import { buttonStyles } from './Button.styles';
import type { TButtonSize } from './Button.types';

export interface IButtonContentProps {
  loading: boolean;
  icon?: React.ReactNode;
  iconPosition?: 'leading' | 'trailing';
  iconOnly?: boolean;
  size?: TButtonSize;
  children: React.ReactNode;
}

export function ButtonContent({
  loading,
  icon,
  iconPosition = 'leading',
  iconOnly,
  size = 'md',
  children,
}: IButtonContentProps) {
  const iconSize = size === 'sm' ? 16 : 18;
  const contentOpacity = loading
    ? buttonStyles.contentLoading
    : buttonStyles.contentVisible;

  return (
    <span className={cx(buttonStyles.content, contentOpacity)}>
      {icon && iconPosition === 'leading' && (
        <ButtonIcon size={iconSize} position="leading" iconOnly={iconOnly}>
          {icon}
        </ButtonIcon>
      )}

      {!iconOnly && <span className={buttonStyles.label}>{children}</span>}

      {icon && iconPosition === 'trailing' && (
        <ButtonIcon size={iconSize} position="trailing" iconOnly={iconOnly}>
          {icon}
        </ButtonIcon>
      )}
    </span>
  );
}
